import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ml-2"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"5px"} }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tirscript-table-header-item", { 'cursor-pointer': !!_ctx.sortName }]),
    style: _normalizeStyle(_ctx.styleCustom),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.sortExecute && _ctx.sortExecute(...args)))
  }, [
    _createElementVNode("div", null, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    (_ctx.sortType != null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: _normalizeClass([{ active: _ctx.sortType == 1 }, _ctx.iconAsc])
          }, null, 2),
          _hoisted_2,
          _createElementVNode("div", {
            class: _normalizeClass([{ active: _ctx.sortType == 0 }, _ctx.iconDesk])
          }, null, 2)
        ]))
      : _createCommentVNode("", true)
  ], 6))
}